import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { LoginService } from '../../login/services/login.service';
import { Firmas } from '../models/firmas';
import { IGestionarFirmasService } from './ports/i-gestionar-firmas-service';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { ResumenEstados, ResumenInicial } from '../models/resumen-inicial';

@Injectable({
  providedIn: 'root'
})
export class GestionaFirmasMockService implements IGestionarFirmasService{

  firmas: Firmas[] = [];
  resumenHome: ResumenInicial;

  constructor(private client: HttpClient,
              private loginService: LoginService ) { }

  cargarResumenHome(): Observable<any>{
    let httpOptions: any ={
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      })
    };
    return this.client.get(`${environment.ApiResumenHomeMock}`, httpOptions).pipe(
      map((response: any)=>{

        return this.resumenHome = response;
        })
      )
  }

  GetFirmas(filtrosSqp: FiltroSqp[], pageNumber:number, pageSize:number = 50, orden: OrdenColumna = {campoOrden:'', orden:''}, refresh?: boolean): Observable<void | any[]> {

    let url;
    if(pageNumber == 0) url = `${environment.ApiFirmasMock1}`;
    else if(pageNumber == 1) url = `${environment.ApiFirmasMock1}`;
    else if(pageNumber == 2) url = `${environment.ApiFirmasMock2}`;
    else if(pageNumber == 3) url = `${environment.ApiFirmasMock3}`;
    else if(pageNumber == 4) url = `${environment.ApiFirmasMock4}`;
    else return of([]);

    // let httpOptions: any ={
    //   headers: new HttpHeaders({
    //     'Content-Type':'application/json',
    //     'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
    //   })
    // };
    return this.client.get(url).pipe(
      map((response: any)=>{
        return this.firmas = response;
        })
      )
  }

  GetInfoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = `${environment.ApiInfoDocsMock}`;
    // /${ this.firmas[index].idFirma}
    //CARGAMOS LOS DOCUMETNOS
    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{

      return  response.Data
    }))

  }

  GetInfoEventos(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = `${environment.ApiInfoEventosMock}`

    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{

      return response.Data;
    }))
  }

  GetInfoTipoDocs(index: number): Observable<any> {
    let httpOptions: any = {
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      }),
    }

    let url = `${environment.ApiInfoTipoDocsMock}`;

    return this.client.get(url, httpOptions).pipe(
      map((response: any)=>{

      return response.Data;
    }))
  }

  BorrarFirmas(ids: number[]): Observable<string> {
    let response = `Mock - Estoy eliminando las firmas con ids: ${ids}`

    return of(response)
  }

  BorrarFirma(idFirma: number): Observable<string> {
    let response = `Mock - Estoy eliminando la firma con id: ${idFirma}`

    return of(response)
  }

  CancelarFirma(idFirma: number): Observable<string> {
    let response = `Mock - Estoy cancelando la firma con id: ${idFirma}`

    return of(response)
  }

  DescargaFirmaCompleta(id: any): Observable<string> {
    let response = `Mock - Estoy descargando la firma con id: ${id}`

    return of(response)
  }

  getResumenEstados(filtrosSqp: FiltroSqp[]): Observable<ResumenEstados[]> {
    let httpOptions: any ={
      headers: new HttpHeaders({
        'Content-Type':'application/json',
        'authorization': 'Bearer '+this.loginService.getUserLocalStorage().Token.Token,
      })
    };
    return this.client.get(`${environment.ApiResumenHomeMock}`, httpOptions).pipe(
      map((response: any)=>{
        return response.resumenEstados;
      })
    );
  }

  getDesplegablesFiltros(): Observable<any> {
    throw new Error('Method not implemented.');
  }

}
